import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

import "./FilterBy.css";
import { useEffect } from "react";

const getSortLabel = (id, options) => {
  const temp = options?.filter((it) => it?.value === id);
  return temp[0]?.label;
};

const FilterBy = (props) => {
  const { sortOptions } = props;

  const [sortByVal, setSortByVal] = useState(
    props.value !== null && props.value !== undefined
      ? getSortLabel(props.value, sortOptions)
      : "SortBy"
  );


  const [sortByEl, setSortByEl] = useState(null);
  const dropDownOpen = Boolean(sortByEl);

  const handleDropdownClick = (event) => {
    setSortByEl(event.currentTarget);
  };

  const handleDropdownChange = (ans, val) => {
    props.handleSortBy(ans, val);
    setSortByVal(ans);
    setSortByEl(null);
  };

  useEffect(() => {
    if (props.value !== null && props.value !== undefined) {
      setSortByVal(getSortLabel(props.value, sortOptions))
    } else {
      setSortByVal("asc")
    }
  }, [props.value, sortOptions]);

  return (
    <div className="filter-block">
      <img
        src="/images/select_icon2.svg"
        alt="arrow"
        className="absolute top-[11px] left-[22px]"
      />
      <img
        src="/images/select_icon1.svg"
        alt="arrow"
        className="absolute top-[15px] right-[2px]"
      />
      <Button
        id="sortby-button"
        aria-controls={dropDownOpen ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={dropDownOpen ? "true" : undefined}
        onClick={handleDropdownClick}
        disabled={props.isDisabled}
      >
        {sortByVal}
      </Button>
      <Menu
        id="sortby-menu"
        anchorEl={sortByEl}
        open={dropDownOpen}
        onClose={() => setSortByEl(null)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {sortOptions.map((item, idx) => (
          <MenuItem
            key={item.value}
            onClick={() => handleDropdownChange(item.label, item?.value)}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default FilterBy;
